export interface LoginBusyFlags {
  isSubmitting: boolean;
  isTelegramSubmitting: boolean;
  isGoogleSubmitting: boolean;
  isAppleSubmitting: boolean;
}

export function isAuthBusy(flags: LoginBusyFlags): boolean {
  return (
    flags.isSubmitting ||
    flags.isTelegramSubmitting ||
    flags.isGoogleSubmitting ||
    flags.isAppleSubmitting
  );
}

export function canSubmitCredentials(flags: LoginBusyFlags): boolean {
  return !isAuthBusy(flags);
}

export function canSubmitTelegramMiniApp(input: {
  isRegisterMode: boolean;
  flags: LoginBusyFlags;
  telegramInitData: string;
}): boolean {
  return (
    !input.isRegisterMode &&
    !isAuthBusy(input.flags) &&
    input.telegramInitData.length >= 10
  );
}

export function canUseTelegramWidget(input: {
  isRegisterMode: boolean;
  isTelegramMiniApp: boolean;
  telegramBotUsername: string;
  flags: LoginBusyFlags;
}): boolean {
  return (
    !input.isRegisterMode &&
    !input.isTelegramMiniApp &&
    Boolean(input.telegramBotUsername.trim()) &&
    !isAuthBusy(input.flags)
  );
}

export function canUseSocialProvider(input: {
  isRegisterMode: boolean;
  isTelegramMiniApp: boolean;
  providerClientId: string;
  flags: LoginBusyFlags;
}): boolean {
  return (
    !input.isRegisterMode &&
    !input.isTelegramMiniApp &&
    Boolean(input.providerClientId.trim()) &&
    !isAuthBusy(input.flags)
  );
}
